import { render } from "./SignPadContainer.vue?vue&type=template&id=1e152ad2"
import script from "./SignPadContainer.vue?vue&type=script&lang=js"
export * from "./SignPadContainer.vue?vue&type=script&lang=js"
script.render = render

export default script